import { Injectable } from '@angular/core';
import { ExternalCloudLocationsApiClient } from './api-clients/external-cloudlocations.api-client';
import CloudItem from '../models/clouditem';
import { tap } from 'rxjs';
import { ModalOpenerService } from '../modals/modal-opener.service';
import { ExternalContentProviders } from '../constants/ExternalContentProviders.enum';
export class ExportRequestModel {
    constructor(
        public requestId: string,
        public exportName: string,
        public cloudItem: CloudItem
    ) { }
}
export class ExportDocumentModel {
    requestId!: string;
    documentId!: string;
    drive!: string;
    folderId!: string;
}



